export const CUSTOM_ENDPOINT = {
  bamboorio: 'https://bamboorio.hqbeds.com.br/api/v1',
  greenhaven: 'https://greenhaven.hqbeds.com.br/api/v1',
};
